import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-[#09090B] text-white/80">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <Link
          to="/login"
          className="inline-flex items-center text-white/40 hover:text-white/70 text-sm mb-8 transition-colors"
          data-testid="privacy-back-link"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour
        </Link>

        <h1 className="font-heading text-3xl md:text-4xl font-bold text-white mb-2">
          Politique de confidentialite
        </h1>
        <p className="text-white/40 text-sm mb-10">
          Derniere mise a jour : 8 avril 2026
        </p>

        <div className="space-y-8 text-[15px] leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">1. Introduction</h2>
            <p>
              Forfaits Vacances Tracker ({'"'}trackvacances.com{'"'}) s{"'"}engage a proteger la vie privee de ses utilisateurs. Cette politique de confidentialite explique quelles informations nous recueillons, comment nous les utilisons et les mesures que nous prenons pour les proteger.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">2. Informations collectees</h2>
            <p className="mb-3">Nous collectons les types d{"'"}informations suivants :</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong className="text-white">Informations de compte :</strong> Lors de votre inscription ou connexion via Google, nous recueillons votre adresse courriel, votre nom et votre photo de profil.
              </li>
              <li>
                <strong className="text-white">Donnees de suivi :</strong> Les URLs des forfaits vacances que vous choisissez de suivre, ainsi que les prix historiques collectes automatiquement.
              </li>
              <li>
                <strong className="text-white">Donnees techniques :</strong> Informations de session necessaires au fonctionnement de l{"'"}application (cookies de session).
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">3. Utilisation des informations</h2>
            <p className="mb-3">Vos informations sont utilisees exclusivement pour :</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Authentifier votre acces a l{"'"}application.</li>
              <li>Suivre les prix des forfaits vacances que vous avez ajoutes.</li>
              <li>Vous envoyer des notifications par courriel lorsqu{"'"}un changement de prix est detecte.</li>
              <li>Ameliorer le fonctionnement et la fiabilite du service.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">4. Authentification Google</h2>
            <p>
              Lorsque vous vous connectez avec Google, nous accedons uniquement a votre profil de base (nom, adresse courriel et photo de profil) via les scopes OAuth {'"'}openid{'"'}, {'"'}email{'"'} et {'"'}profile{'"'}. Nous ne demandons aucun acces a vos contacts, calendrier, fichiers ou autres donnees Google. Votre mot de passe Google n{"'"}est jamais transmis a notre application.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">5. Partage des informations</h2>
            <p>
              Nous ne vendons, n{"'"}echangeons ni ne louons vos informations personnelles a des tiers. Vos donnees ne sont partagees avec aucun service externe, a l{"'"}exception des services essentiels au fonctionnement de l{"'"}application :
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>
                <strong className="text-white">Google OAuth :</strong> Pour l{"'"}authentification securisee.
              </li>
              <li>
                <strong className="text-white">Resend :</strong> Pour l{"'"}envoi de notifications par courriel concernant les changements de prix.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">6. Stockage et securite des donnees</h2>
            <p>
              Vos donnees sont stockees de maniere securisee dans une base de donnees chiffree. Les sessions d{"'"}authentification utilisent des cookies HTTP-only securises. Nous appliquons des mesures de securite appropriees pour proteger vos informations contre tout acces, modification ou divulgation non autorises.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">7. Conservation des donnees</h2>
            <p>
              Vos donnees sont conservees aussi longtemps que votre compte est actif. Vous pouvez supprimer vos forfaits suivis a tout moment. Si vous souhaitez supprimer completement votre compte et toutes les donnees associees, veuillez nous contacter par courriel.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">8. Vos droits</h2>
            <p className="mb-3">Vous avez le droit de :</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Acceder aux informations personnelles que nous detenons a votre sujet.</li>
              <li>Demander la correction de vos informations.</li>
              <li>Demander la suppression de votre compte et de vos donnees.</li>
              <li>Retirer votre consentement a tout moment en cessant d{"'"}utiliser le service.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">9. Cookies</h2>
            <p>
              Nous utilisons des cookies de session strictement necessaires au fonctionnement de l{"'"}application. Ces cookies permettent de maintenir votre session d{"'"}authentification. Nous n{"'"}utilisons aucun cookie de suivi publicitaire ou analytique tiers.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">10. Modifications</h2>
            <p>
              Nous nous reservons le droit de modifier cette politique de confidentialite a tout moment. Les modifications seront publiees sur cette page avec la date de mise a jour. Votre utilisation continue du service apres toute modification constitue votre acceptation de la politique mise a jour.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">11. Contact</h2>
            <p>
              Pour toute question concernant cette politique de confidentialite ou vos donnees personnelles, veuillez nous contacter a l{"'"}adresse suivante : <a href="mailto:contact@trackvacances.com" className="text-blue-400 hover:underline">contact@trackvacances.com</a>
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-center text-white/30 text-xs">
          Forfaits Vacances Tracker &mdash; trackvacances.com
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
